import axios from 'axios';
import {
    SUBJECT_LIST_REQUEST, SUBJECT_LIST_SUCCESS, SUBJECT_LIST_FAIL,
    SUBJECT_LIST_BY_IDS_REQUEST, SUBJECT_LIST_BY_IDS_SUCCESS, SUBJECT_LIST_BY_IDS_FAIL,
    SUBJECT_DETAILS_REQUEST, SUBJECT_DETAILS_SUCCESS, SUBJECT_DETAILS_FAIL,
    SUBJECT_CREATE_REQUEST, SUBJECT_CREATE_SUCCESS, SUBJECT_CREATE_FAIL,
    SUBJECT_UPDATE_REQUEST, SUBJECT_UPDATE_SUCCESS, SUBJECT_UPDATE_FAIL,
    SUBJECT_DELETE_REQUEST, SUBJECT_DELETE_SUCCESS, SUBJECT_DELETE_FAIL,
    SUBJECT_DTO_REQUEST, SUBJECT_DTO_SUCCESS, SUBJECT_DTO_FAIL,
} from '../constants/subjectConstants';
import { formatApiError } from '../utils/formatApiError';

// Helper functions
const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    if (error.response?.status === 403) {
        return [formatApiError(error)];
    }
    const errorMessages = [];
    if (error.response?.data) {
        if (error.response.data.errors) {
            Object.entries(error.response.data.errors).forEach(([key, value]) => {
                errorMessages.push(`${key}: ${value[0]}`);
            });
        }
        if (error.response.data.detail) {
            errorMessages.push(`Detail: ${error.response.data.detail}`);
        }
        if (error.response.data.message) {
            errorMessages.push(`Message: ${error.response.data.message}`);
        }
    }
    return errorMessages.length > 0 ? errorMessages : [error.message || "An error occurred, please try again later"];
};

const API_BASE_URL = '/dotnet_api/v1/subject';

export const listSubjects = (params = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: SUBJECT_LIST_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params
        };
        const { data } = await axios.get(`${API_BASE_URL}/all`, config);
        dispatch({ type: SUBJECT_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: SUBJECT_LIST_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const listSubjectsByIds = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: SUBJECT_LIST_BY_IDS_REQUEST });
        const { data } = await axios.post(
            `${API_BASE_URL}/ids/all`,
            ids,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: SUBJECT_LIST_BY_IDS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: SUBJECT_LIST_BY_IDS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getSubjectDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: SUBJECT_DETAILS_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: SUBJECT_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: SUBJECT_DETAILS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const createSubject = (subjectData) => async (dispatch, getState) => {
    try {
        dispatch({ type: SUBJECT_CREATE_REQUEST });
        const { data } = await axios.post(
            API_BASE_URL,
            subjectData,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: SUBJECT_CREATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: SUBJECT_CREATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const updateSubject = (id, changes) => async (dispatch, getState) => {
    try {
        dispatch({ type: SUBJECT_UPDATE_REQUEST });
        const { data } = await axios.patch(
            `${API_BASE_URL}/${id}`,
            changes,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: SUBJECT_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: SUBJECT_UPDATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const deleteSubject = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: SUBJECT_DELETE_REQUEST });
        await axios.delete(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: SUBJECT_DELETE_SUCCESS });
    } catch (error) {
        dispatch({ type: SUBJECT_DELETE_FAIL, payload: formatErrorMessage(error) });
    }
};

export const loadSubjectDto = () => async (dispatch, getState) => {
    try {
        dispatch({ type: SUBJECT_DTO_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/dto`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: SUBJECT_DTO_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: SUBJECT_DTO_FAIL,
            payload: formatErrorMessage(error)
        });
    }
}; 